import { gql } from '@apollo/client';

export const ALL_REPORTS_TEMPLATES = gql`
  query AllReportsTemplates($input: ReportTemplatesInput) {
    reportsTemplates: allReportTemplates(input: $input) {
      aggregate {
        count
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          id
          name
          text
          createdBy {
            id
            firstName
          }
        }
      }
    }
  }
`;
